var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useFeatureSettings } from '@office-start/feature-settings-service';
import { SUSPEND_ON_CLOSE_KEY, useShouldRunAppInBackground, } from '@office-start/hwa-native-bridge-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { logError, logPerformance } from '@office-start/telemetry-service';
import { useCallback, useEffect, useRef } from 'react';
var logReactivationPerf = function (eventName) {
    try {
        // Todo: Fix types
        var Windows = window.Windows;
        var reactivationStartTime = Windows.System.Diagnostics.ProcessDiagnosticInfo.getForCurrentProcess().lastReactivationStartTime.getTime();
        var latency = Date.now() - reactivationStartTime;
        logPerformance({ eventName: eventName, latency: latency });
    }
    catch (_a) {
        // Do nothing if projections are not set.
    }
};
export var useWindowsAppLifecycleHandler = function (workload) {
    var _a, _b, _c, _d;
    var featureSettings = useFeatureSettings().data;
    var shouldRunAppInBackground = useShouldRunAppInBackground().shouldRunAppInBackground;
    var runDesktopInBackgroundEnabled = shouldRunAppInBackground;
    var timerRef = useRef(null);
    var refreshWebApp = useCallback(function () {
        if (navigator.onLine) {
            var targetUrl = new URL(window.location.href);
            targetUrl.pathname = '/pwa';
            window.location.href = targetUrl.href;
            timerRef.current = null;
        }
    }, []);
    var handleOnSuspended = useCallback(function () {
        var _a, _b;
        if (!timerRef.current) {
            var firstRefreshDelaySec = parseInt(((_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.hwaSuspendSettings) === null || _b === void 0 ? void 0 : _b.firstRefreshDelaySec) || '', 10);
            // Default wait time is 10 * 60 seconds
            if (isNaN(firstRefreshDelaySec))
                firstRefreshDelaySec = 600;
            timerRef.current = setTimeout(function () {
                refreshWebApp();
            }, firstRefreshDelaySec * 1000);
        }
    }, [
        (_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.hwaSuspendSettings) === null || _b === void 0 ? void 0 : _b.firstRefreshDelaySec,
        refreshWebApp,
    ]);
    var handleBackgroundRefresh = useCallback(function () {
        var _a, _b;
        if (!timerRef.current) {
            var backgroundRefreshIntervalSec = parseInt(((_b = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _a === void 0 ? void 0 : _a.hwaSuspendSettings) === null || _b === void 0 ? void 0 : _b.refreshIntervalSec) || '', 10);
            // Default background refresh interval is 360 * 60 seconds
            if (isNaN(backgroundRefreshIntervalSec))
                backgroundRefreshIntervalSec = 21600;
            timerRef.current = setInterval(function () {
                refreshWebApp();
            }, backgroundRefreshIntervalSec * 1000);
        }
    }, [
        (_d = (_c = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.result) === null || _c === void 0 ? void 0 : _c.hwaSuspendSettings) === null || _d === void 0 ? void 0 : _d.refreshIntervalSec,
        refreshWebApp,
    ]);
    var handleOnResumed = useCallback(function () {
        logReactivationPerf('HWAResumedFromBackground');
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);
    var handleAppLifecycleEvent = useCallback(function (eventArgs) {
        switch (eventArgs === null || eventArgs === void 0 ? void 0 : eventArgs.appState) {
            case 'suspended':
                handleOnSuspended();
                break;
            case 'resumed':
                handleOnResumed();
                break;
        }
    }, [handleOnResumed, handleOnSuspended]);
    var listenersAttached = useRef(false);
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var saveToLocalStorage, Windows, _a, isSuspended, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 6, , 7]);
                        if (workload !== OfficeWorkload.Hwa) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, import('@office-start/hwa-native-bridge-service')];
                    case 1:
                        saveToLocalStorage = (_b.sent()).saveToLocalStorage;
                        Windows = window.Windows;
                        if (!runDesktopInBackgroundEnabled) {
                            if (timerRef.current) {
                                clearTimeout(timerRef.current);
                                timerRef.current = null;
                            }
                            return [2 /*return*/];
                        }
                        if (!!listenersAttached.current) return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 3, , 5]);
                        //Todo: Move to utils function
                        Windows.UI.WebUI.WebUIApplication.addEventListener('appLifecycleEvent', function (eventArgs) {
                            handleAppLifecycleEvent(eventArgs);
                        });
                        listenersAttached.current = true;
                        return [3 /*break*/, 5];
                    case 3:
                        _a = _b.sent();
                        return [4 /*yield*/, saveToLocalStorage(SUSPEND_ON_CLOSE_KEY, false)];
                    case 4:
                        _b.sent();
                        logError({
                            eventName: 'WindowsAppLifecycleHandler',
                            message: 'Failed to attach event listeners',
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        isSuspended = void 0;
                        try {
                            isSuspended =
                                Windows.UI.WebUI.WebUIApplication.current().getAppState() ===
                                    'Suspended';
                        }
                        catch (error) {
                            isSuspended = false;
                        }
                        if (isSuspended) {
                            handleBackgroundRefresh();
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _b.sent();
                        logError({
                            eventName: 'WindowsAppLifecycleHandler',
                            message: "Error in useWindowsAppLifecycleHandler: ".concat(error_1),
                        });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        }); })();
    }, [
        runDesktopInBackgroundEnabled,
        handleBackgroundRefresh,
        handleAppLifecycleEvent,
        workload,
    ]);
};
//# sourceMappingURL=useWindowsAppLifecycleHandler.js.map